/**
 * Shared Metric stat block used by every System Status section card.
 */

import React from 'react'
import { Box, Typography } from '@mui/material'

export interface MetricProps {
  label: string
  value: number | string
  color?: string
}

const Metric: React.FC<MetricProps> = ({ label, value, color }) => (
  <Box sx={{ textAlign: 'center' }}>
    <Typography
      variant="h4"
      component="div"
      sx={{ color: color || 'text.primary', fontWeight: 'bold' }}
    >
      {value}
    </Typography>
    <Typography variant="body2" color="text.secondary">
      {label}
    </Typography>
  </Box>
)

export default Metric
